module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (48).a1b4d95e.jpg";